import React, {useCallback, useMemo, useState} from "react";
import "./index.scss";
import Title from "features/components/title";
import {__} from "services/i18n";
import Text from "features/components/text";
import PaymentMethodSvg from "images/payment-methods.svg";
import PaymentGatewaySvg from "images/payment-gateway.svg";
import {array, bool, func} from "prop-types";
import {CardNumberElement, ElementsConsumer} from "@stripe/react-stripe-js";
import {PaymentCard} from "features/components/payment-card";
import {Icon} from "features/components/icon";

export const PaymentForm = (props) => {
    const {onChange, elements, savedCards, deleteEnabled = false, onDelete} = props;

    const [complete, setComplete] = useState(false);

    React.useEffect(() => {
        const card = elements.getElement(CardNumberElement);
        onChange({
            card,
            valid: complete
        })
    }, [onChange, complete, elements]);

    const [selected_card, setSelectedCard] = useState(((savedCards || []).length > 0 && !deleteEnabled) ? savedCards[0].stripe_id : "new");

    React.useEffect(() => {
        if (selected_card === "new") {
            const card = elements.getElement(CardNumberElement);
            onChange({
                card,
                valid: complete
            });
        } else {
            onChange({
                stripe_id: selected_card,
                valid: true
            });
        }
    }, [complete, elements, onChange, selected_card]);

    const renderSavedCards = useCallback(() => {
        if(!savedCards || savedCards.length === 0) {
            return null;
        }
        return <div className="saved-cards">
            {savedCards.map(i => <div id={i.stripe_id} onClick={() => setSelectedCard(i.stripe_id)} key={i.stripe_id}  className={selected_card === i.stripe_id ? "selected" : ""}><span /><Title size={18}>{__("common.card")} {i.brand} **** **** **** {i.last_numbers} - {i.month}/{i.year}</Title></div>)}
            <div onClick={() => setSelectedCard("new")} className={selected_card === "new" ? "selected" : ""}><span /><Title size={18}>{__("common.new-card")} +</Title></div>
        </div>
    }, [savedCards, selected_card]);

    const renderCardsForDeletion = useCallback(() => {
        if(!savedCards || savedCards.length === 0) {
            return null;
        }
        return <div className="saved-cards">
            {savedCards.map(i => <div id={i.stripe_id} key={i.stripe_id} className="card-delete"><div onClick={() => onDelete(i.stripe_id)}><Icon>{i.deleting ? "loader" : "delete"}</Icon></div><Title size={18}>{__("common.card")} {i.brand} **** **** **** {i.last_numbers} - {i.month}/{i.year}</Title></div>)}
        </div>
    }, [onDelete, savedCards]);

    const newCardActive = useMemo(() => {
        return (!savedCards || savedCards.length === 0) || selected_card === "new";
    }, [savedCards, selected_card]);

    return <div className={"payment-form"}>
        <Title size={18}>{__("forms.payment.title")}</Title>
        <div className="row">
            <Text size={16}>{__("forms.payment.text")}</Text>
            <div className={"methods"}>
                <img src={PaymentGatewaySvg} alt={"Payment Gateway"}/>
                <img src={PaymentMethodSvg} alt={"Payment Methods"}/>
            </div>
        </div>
        {deleteEnabled ? renderCardsForDeletion() : renderSavedCards()}
        <div className={`form-field ${newCardActive ? "enabled" : "disabled"}`}>
            <PaymentCard onChange={setComplete}/>
        </div>
    </div>
};

PaymentForm.propTypes = {
    onChange: func.isRequired,
    savedCards: array,
    deleteEnabled: bool,
    onDelete: func
};

export const PaymentFormBaseState = {

}
/*istanbul ignore next*/
const PaymentFormStripe = (props) => (
    <ElementsConsumer>
        {({stripe, elements}) => (
            <PaymentForm stripe={stripe} elements={elements} {...props} />
        )}
    </ElementsConsumer>
);
export default PaymentFormStripe;
